import React, { useState, useCallback, useEffect } from "react";

import { debounce } from "lodash";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { Range } from "react-range";
import StandardButton from "../../../../shared/formComponents/StandardButton/StandardButton";
import { getProgressBarColour } from "../../../../../utils/generalUtils";
import {
  SmallLightText,
  SmallNormalText,
} from "../../../../../utils/typographyUtils";
import { StandardTooltip } from "../../../../shared/StandardTooltip/StandardTooltip";

export const InitiativeAccordionItem = ({
  intiativeItem,
  showInitiativeInput,
  index,
  setShowInitiativeInput,
  buttonDisabled,
  isLastItem,
  isViewMode,
  showDeleteInitiativePopup,
  setShowDeleteInitiativePopup,
  editMode,
  hideProgressBar,
  handleUpdateInitiativePercentage,
  disableOperations,
  handleUpdateBusinessPlanInitiative,
  handleDeleteBusinessPlanInitiative,
  handleUpdateInitiativeProgress,
  showActions,
}) => {
  const [originalInitiative, setOriginalInitiative] = useState(
    intiativeItem.initiative
  );
  const [localPercentage, setLocalPercentage] = useState(
    intiativeItem.progressPercentage
  );

  useEffect(() => {
    setLocalPercentage(intiativeItem.progressPercentage);
  }, [intiativeItem.progressPercentage]);

  const debouncedApiCall = useCallback(
    debounce((value, initiativeId) => {
      handleUpdateInitiativeProgress(initiativeId, value);
    }, 1000),
    []
  );

  const handleUpdateInitiative = (value) => {
    setOriginalInitiative(value);
  };
  const handleShowButtons = () => {
    const color =
      showInitiativeInput.type === "delete"
        ? "btn-border-danger"
        : "btn-outline-brand-blue-new";
    const text = showInitiativeInput.type === "delete" ? "Delete" : "Update";

    const cancelButton = (
      <StandardButton
        disabled={buttonDisabled}
        color="btn-border"
        className="py-1"
        text="Cancel"
        onClick={() => {
          setShowInitiativeInput({ show: false, type: "" });
          setOriginalInitiative(intiativeItem.initiative);
        }}
      />
    );

    if (
      showInitiativeInput.id === intiativeItem.initiativeId &&
      showInitiativeInput.show
    ) {
      return (
        <div className="d-flex align-items-center">
          {cancelButton}
          <StandardButton
            color={color}
            className="mx-2 py-1"
            text={text}
            onClick={() => {
              if (showInitiativeInput.type === "update") {
                handleUpdateBusinessPlanInitiative(
                  intiativeItem.initiativeId,
                  originalInitiative
                );
              } else {
                handleDeleteBusinessPlanInitiative(intiativeItem.initiativeId);
              }
            }}
            darkLoader={true}
            disabled={buttonDisabled}
            isLoading={buttonDisabled}
          />
        </div>
      );
    }
    return (
      <div
        className="d-flex align-items-center"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {!hideProgressBar ? (
          <div className="d-flex mx-2 align-items-center">
            <Range
              step={10}
              min={0}
              max={100}
              values={[localPercentage]}
              onChange={(values) => {
                setLocalPercentage(values[0]);
                handleUpdateInitiativePercentage(
                  index,
                  "progressPercentage",
                  values[0]
                );
              }}
              onFinalChange={(values) => {
                handleUpdateInitiativeProgress(
                  intiativeItem.initiativeId,
                  values[0]
                );
              }}
              disabled={disableOperations}
              renderTrack={({ props, children }) => (
                <div
                  {...props}
                  style={{
                    ...props.style,
                    height: "12px",
                    borderRadius: "8px",
                    width: "120px",
                    backgroundColor: "#ccc",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      height: "12px",
                      width: `${localPercentage}%`,
                      borderRadius: "8px",
                      background: getProgressBarColour(localPercentage),
                    }}
                  >
                    {children}
                  </div>
                </div>
              )}
              draggableTrack={true}
              renderThumb={({ props }) => {
                if (!disableOperations) {
                  return (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: "12px",
                        width: "12px",
                        borderRadius: "50%",
                        backgroundColor: "#F4F4F4",
                        border: "1px solid #056C75",
                        position: "absolute",
                        top: "0",
                        left: `${localPercentage}%`,
                        transform: "translateX(-50%)",
                      }}
                    />
                  );
                } else {
                  return null;
                }
              }}
            />
            <SmallLightText classNames={"ms-3 percentage-label"}>
              {localPercentage}%
            </SmallLightText>
          </div>
        ) : // <input
        //   value={localPercentage}
        //   type="number"
        //   className="form-control"
        //   min="0"
        //   max="100"
        //   onChange={isViewMode ? null : handleChange}
        //   onBlur={isViewMode ? null : handleBlur}
        // />
        //   <div className="slider-wrapper">
        //   <RangeSlider
        //     value={localPercentage}
        //     onInput={(e)=>handleChange(e[1])}
        //     onThumbDragEnd={isViewMode ? null : handleBlur}
        //     thumbsDisabled={[true,false]}
        //     rangeSlideDisabled={true}
        //     min={0}
        //     max={100}
        //     className="red-slider"
        //   />
        //   <span className="percentage-label">{localPercentage}%</span>
        // </div>
        null}
        {renderDeleteIcon()}
      </div>
    );
  };

  const handleChange = (value) => {
    setLocalPercentage(value[0]);
    handleUpdateInitiativePercentage(index, "progressPercentage", value[0]);
  };

  const handleBlur = (e) => {
    const value = e.target.value;
    if (value == 0) {
      return;
    }
    if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
      handleUpdateInitiativeProgress(intiativeItem.initiativeId, value);
    }
  };

  const renderDeleteIcon = () => {
    if (!showActions) {
      return null;
    }

    const handleDeleteClick = () => {
      if (!showActions) {
        return;
      }

      setShowDeleteInitiativePopup({
        show: true,
        type: "delete",
        id: intiativeItem.initiativeId,
      });
    };
    if (isLastItem) {
      return (
        <StandardTooltip
          tooltTipContent={"Can't delete — at least one initiative required"}
        >
          <img
            src="/assets/images/deleteIcon-disabled.svg"
            className={`ps-3 cursor-disabled initiative-delete-icon`}
          />
        </StandardTooltip>
      );
    }
    return (
      <img
        src="/assets/images/deleteIcon.svg"
        className={`cursor-disabled initiative-delete-icon ps-3`}
        onClick={handleDeleteClick}
      />
    );
  };

  return (
    <div id="initiatives-item">
      <div className="row px-3 cursor-pointer">
        <div className="col-12 initiatives-result-item-main">
          <div className="row">
            <div className="col-9">
              <div className="d-flex align-items-center w-100">
                <div className="me-4">
                  <SmallNormalText classNames={"me-2"}>
                    {index + 1}
                  </SmallNormalText>
                </div>
                <SmallNormalText
                  classNames={`${disableOperations ? "" : "cursor-pointer"}`}
                  onClick={() => {}}
                >
                  {intiativeItem.initiative}
                </SmallNormalText>
              </div>
            </div>
            <div className=" col-3">{handleShowButtons()}</div>
          </div>
        </div>
      </div>
      {/* <div className="d-flex align-items-center w-100">
        <div className="d-flex align-items-center p-2 justify-content-between w-100">
          <div className="d-flex align-items-center w-100">
            <SmallNormalText classNames={"me-2"}>{index + 1}</SmallNormalText>
            <SmallNormalText            
              onClick={() => {
                
              }}
            >
              {intiativeItem.initiative}
            </SmallNormalText>
          </div>
        </div>
        <div className="initiative-input-div d-flex align-items-center">
          {handleShowButtons()}
        </div>
      </div> */}
    </div>
  );
};
